import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Alerts, TitleValue, Slider } from '@kaleyra/emmy';


import Styles from './index.module.scss';

export type DispatchPropsType = {
	onClose: () => void;
};

const LookUp: React.FC<DispatchPropsType> = ({ onClose }) => {
	const { t } = useTranslation();

	return (
		<Slider
			visibility={true}
			containerId={'root-modal'}
			onClose={onClose}
			title={t('BLD00372')}
		>
			<div className={Styles.container}>
				<Card>
					<div className={Styles.lookupContainer}>
						<TitleValue
							label={t('mainETACost')}
							labelPosition={'right'}
						>
							<h3>$0.053553</h3>
						</TitleValue>
						<p>
							₹ 14027.49 would be your account balance after the
							campaign
						</p>
					</div>
				</Card>
				<Alerts
					type={'warning'}
					label={
						'Above cost is tentative only, you can find the actual cost after successful execution of the lookup'
					}
					showIcon={false}
				/>
			</div>
		</Slider>
	);
};

export default LookUp;
